
export const types = {
    GETTING_RESULT: 'GETTING_RESULT',
    GET_RESULT_SUCCESS: 'GET_RESULT_SUCCESS',
    GET_RESULT_FAIL: 'GET_RESULT_FAIL',
    CLEAR_RESULT_ERR_MSG: 'CLEAR_RESULT_ERR_MSG'
}